// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OkryV","content":"styles_content__y6KZ0"};